module.exports = __webpack_public_path__ + "img/snezana_n.570c907d.png";